import { render, staticRenderFns } from "./Availability.vue?vue&type=template&id=0bdd9d2f&scoped=true"
import script from "./Availability.vue?vue&type=script&lang=js"
export * from "./Availability.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bdd9d2f",
  null
  
)

export default component.exports